module.exports = __webpack_public_path__ + "img/OTR.ad0accb4.png";